/**
 * @generated SignedSource<<d94222c18430a2efb1b3c76c53992843>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DiscoVideoFragment$data = {
  readonly aspectRatio: string | null;
  readonly id: string;
  readonly muxAssetPlaybackId: string | null;
  readonly name: string;
  readonly url: string;
  readonly videoDuration: number | null;
  readonly " $fragmentType": "DiscoVideoFragment";
};
export type DiscoVideoFragment$key = {
  readonly " $data"?: DiscoVideoFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DiscoVideoFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DiscoVideoFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "muxAssetPlaybackId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "aspectRatio",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "videoDuration",
      "storageKey": null
    }
  ],
  "type": "Asset",
  "abstractKey": null
};

(node as any).hash = "aeecd686762e858a2c5806369afa84d2";

export default node;
